module.exports = __webpack_public_path__ + "img/loyalty-template.2273e4fa.png";